import {InjectionToken} from '@angular/core';

import {Environment} from './environment.interface';
import { ImageUtil } from '@qid/core';

/**
 * @const ENVIRONMENT
 * Injection token for the environment interface to be provided by the applications.
 */
export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');

let _env: Environment | null = null;

/** Called once by Angular (bootstrap) */
export function setEnv(env: Environment) {
  _env = env;
  ImageUtil.setImageBaseUrl(env?.imageBaseUrl);
}

export function getEnv(): Environment {
    if (!_env) throw new Error('ENV not initialized yet!');
    return _env;
  }